import { FunctionComponent, useEffect, useState } from 'react';
import Link from 'next/link';
import { oneLine } from 'common-tags';

import { Facebook, Twitter, WhatsApp } from '@/icons';
import { Button, UnderlineTag } from '@/atoms';
import { Prose, SocialMedia } from '@/molecules';

import { TypeBlogArticleProps } from './types';
import { ButtonVariant } from '@/atoms/button/types';
import { BreadCrumbs } from '@/components/layouts/breadcrumbs';
import { readingTime } from '@/utils/utils';

export const BlogArticle: FunctionComponent<TypeBlogArticleProps> = ({
  className = '',
  content,
  id,
}: TypeBlogArticleProps) => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    setUrl(document.URL);
  }, []);
  const date = content.changed
    ? new Date(content.changed).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    : new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

  const reading = readingTime(content.field_reading_time, content.field_text ? content.field_text.value : '');
  return (
    <div
      className={oneLine`
      flex flex-col gap-6 md:gap-12
      ${className}
    `}
      id={id}
    >
      <UnderlineTag position="left" theme="light">
        {content.field_category.name}
      </UnderlineTag>
      <BreadCrumbs content={content} />

      <h1 className="text-headline text-headline--h2">{content.title}</h1>

      <div className="flex flex-col gap-2 md:flex-row text-body text-body--m">
        <span>{date}</span>
        {reading && (
          <span className="text-text-secondary">{reading ? `${reading} min de lectura` : null}</span>
        )}
      </div>
      <SocialMedia
        title="COMPÁRTELO"
        socialMedias={[
          {
            Icon: Facebook,
            href: `https://www.facebook.com/sharer.php?u=${url}`,
          },
          {
            Icon: Twitter,
            href: `https://twitter.com/intent/tweet?url=${url}&text=${content.title}`,
          },
          {
            Icon: WhatsApp,
            href: `https://api.whatsapp.com/send?text=${content.title}%20${url}`,
          },
        ]}
        isColumn
        variant="gray"
        position="start"
      />
      {
        content.field_links.length > 0 &&
        <div className='flex flex-wrap gap-4'>
          {
            content.field_links.map((link, index) => (
              <Link href={link.url} key={`field-links-${index}`}>
                <Button as='div' variant={ButtonVariant.PRIMARY} >
                  {link.title}
                </Button>
              </Link>
            ))}
        </div>
      }
      <Prose html={content.field_text} className="text-[large] md:text-base md:leading-[28px]" />

      <hr className="text-secondary-200" />

      <SocialMedia
        title="COMPÁRTELO"
        socialMedias={[
          {
            Icon: Facebook,
            href: `https://www.facebook.com/sharer.php?u=${url}`,
          },
          {
            Icon: Twitter,
            href: `https://twitter.com/intent/tweet?url=${url}&text=${content.title}`,
          },
          {
            Icon: WhatsApp,
            href: `https://api.whatsapp.com/send?text=${content.title}%20${url}`,
          },
        ]}
        isColumn
        variant="gray"
        position="start"
      />
    </div >
  );
};

BlogArticle.displayName = 'BlogArticle';
